import types from 'actions/types'
import {combineReducers} from 'redux'

export const index = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_CHART_DIALOG:
      return action.index
    case types.HIDE_CHART_DIALOG:
      return null
    default:
      return state
  }
}

export const layoutId = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_CHART_DIALOG:
      return action.layoutId
    case types.HIDE_CHART_DIALOG:
      return null
    default:
      return state
  }
}

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_CHART_DIALOG:
      return true
    case types.HIDE_CHART_DIALOG:
      return false
    default:
      return state
  }
}

export const isEditing = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_CHART_DIALOG:
      return action.isEditing
    case types.HIDE_CHART_DIALOG:
      return false
    default:
      return state
  }
}

export const chart = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_CHART_DIALOG:
      return action.chart
    case types.HIDE_CHART_DIALOG:
      return null
    default:
      return state
  }
}

export default combineReducers({
  index,
  layoutId,
  isVisible,
  isEditing,
  chart,
})